import styled from '@emotion/styled'
import { Box } from '@mui/material'
import React, { ReactNode } from 'react'

const StyledWrapper = styled(Box)({
  width: '90%',
  maxWidth: '400px',
  borderRadius: '10px',
  boxShadow: '0 19px 25px 0 rgba(210, 210, 210, 0.1)',
  backgroundColor: '#fff',
  padding: '20px',
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'column',
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
})

const ModalContentWrapper = ({ children }: {children: ReactNode}) => {
  return <StyledWrapper>{children}</StyledWrapper>
}

export default ModalContentWrapper
